import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, ModalHeader, ModalFooter } from 'reactstrap';
import { Button, Modal, ModalBody } from 'reactstrap';
import classnames from 'classnames';
import axios from 'axios';
import {
  APIURL,
  IMAGE_FULL_URL,
  IMAGE_NOPHOTO_URL,
  IMAGE_PDF_URL,
  IMAGE_UPLOAD_ERROR
} from '../../../config/config';
import SalesEdit from '../SalesEdit/SalesEdit';
import SalesPriceEdit from '../SalesPriceEdit';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import * as moment from 'moment';
import 'moment/locale/th';
import ThaiBaht from 'thai-baht-text';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import DatePicker from 'react-datepicker';
import DocUtil from '../../../utils/docUtil';
import { AlertSuccess } from '../../Alert/Alert';
import OutstandingBalanceComponent from "../OutstandingBalanceComponent";
import Swal from "sweetalert2";
import AgentModal from '../../Agent/AgentModal';
// import ReactQuill from 'react-quill'
import parse from 'html-react-parser'

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew-Regular.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

class SalesDetail extends Component {

  constructor (props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = {
      user: {},
      activeTab: '1',
      car_sell: {},
      car_sell_id: '',
      car: {},
      car_brand: {},
      car_id: '',
      primary: false,
      toggle_pay_add: false,
      car_sell_pay_list: [],
      car_sell_pay_selected: {},
      toggle_car_sell_pay_edit: false,
      date_pay: new Date(), //moment(new Date()).format('YYYY-MM-DD'),//moment(),
      car_sell_list_pay: [],
      car_sell_list_pay_id: 0,
      car_sell_pay_count: 0,
      car_sell_pay_count_old: 0,
      sales_type: [],
      sales_type_id: 0,
      car_sell_pay_id: 0,
      bank: [],
      //
      sale_doc1_name : '',
      sale_doc1: IMAGE_NOPHOTO_URL,
      sale_doc1_full: IMAGE_NOPHOTO_URL,
      //
      sale_doc2_name : '',
      sale_doc2: IMAGE_NOPHOTO_URL,
      sale_doc2_full: IMAGE_NOPHOTO_URL,
      // รายรับ
      vat_sell: 0,
      finance_commission: 0,
      // รายจ่าย
      car_external_commission: 0,
      sales_commission: 0,
      additional_commission: 0,
      advertising_cost: 0,
      delivery_fee: 0,
      promotion_fee: 0,
      finance_fee: 0,
      transfer_fee: 0,
      toggle_sell_price: false,
      refund: false,
      car_book_refund: 0,
      width: 0,
      height: 0,
      // นายหน้า
      isAgentModal: false,
      agent_id: 0,
      agentSelected: null,
      agent_fullname: '-',
      agent_mobile: '-',
      sell_finance_contract: '-',
      sell_comment: ''
      // car_sell_pay_id:0,
      // car_sell_pay_count:0,
      // car_sell_pay_selected: {},
    }
    this.toggleCarSellEdit = this.toggleCarSellEdit.bind(this);
    this.toggleCarSellPayAdd = this.toggleCarSellPayAdd.bind(this);
    this.handleDatePay     = this.handleDatePay.bind(this);
    this.handleCarSellPayEditSubmit = this.handleCarSellPayEditSubmit.bind(this);
    this.handleCarSellPayAddSubmit = this.handleCarSellPayAddSubmit.bind(this);
    this.carSellPayAdd = this.carSellPayAdd.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.saveCarImage = this.saveCarImage.bind(this);
    this.toggleCarSellPriceEdit = this.toggleCarSellPriceEdit.bind(this);
    this.refundCarBook = this.refundCarBook.bind(this);
    this.toggleRefund = this.toggleRefund.bind(this);
    this.carPayRefund = this.carPayRefund.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.toggleAgentModal = this.toggleAgentModal.bind(this);
    this.loadAgentByID = this.loadAgentByID.bind(this);
    this.loadDataCarSellPay = this.loadDataCarSellPay.bind(this);
  }

  toggle (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  handleUploadFile (event){
    const input_file_name = event.target.name
    const that = this;
    // const car_sell = this.state.car_sell
    const car_sell_id = this.state.car_sell_id
    // sale_doc_key1 , sale_doc_key2

    const data = new FormData();
    data.append('uploads', event.target.files[0], event.target.files[0].name)
    data.append('car_sell_id', car_sell_id)

    if( input_file_name === 'sale_doc1'){
      const sale_doc_key1 = this.state.sale_doc_key1
      this.refs.img_sale_doc1.src='img/loading.gif'
      this.refs.img_sale_doc1.height=32
      data.append('img_position', 'sale_doc1');
      data.append('sale_doc_key', sale_doc_key1);
    } else if (input_file_name === 'sale_doc2') {
      const sale_doc_key2 = this.state.sale_doc_key2
      this.refs.img_sale_doc2.src='img/loading.gif'
      this.refs.img_sale_doc2.height=32
      data.append('img_position', 'sale_doc2');
      data.append('sale_doc_key', sale_doc_key2);
    } else if (input_file_name === 'sale_doc3') {
      const sale_doc_key3 = this.state.sale_doc_key3
      this.refs.img_sale_doc3.src='img/loading.gif'
      this.refs.img_sale_doc3.height=32
      data.append('img_position', 'sale_doc3');
      data.append('sale_doc_key', sale_doc_key3);
    } else if (input_file_name === 'sale_doc4') {
      const sale_doc_key4 = this.state.sale_doc_key4
      this.refs.img_sale_doc4.src='img/loading.gif'
      this.refs.img_sale_doc4.height=32
      data.append('img_position', 'sale_doc4');
      data.append('sale_doc_key', sale_doc_key4);
    }

    axios.put(APIURL+'/car_sell/doc2/'+car_sell_id, data).then(function(res) {
      const resData = res.data;
      const filename = resData.image;
      const sale_doc_key = resData.sale_doc_key;
      let image_url = ''

      if(resData.image === undefined) {
        image_url = IMAGE_UPLOAD_ERROR
      } else if (resData.image === 'uploaderror') {
        image_url = IMAGE_UPLOAD_ERROR
      } else {
        if (filename.includes('https')) {
          image_url = filename
        } else {
          image_url =  IMAGE_FULL_URL+filename
        }
      }

      if( input_file_name === 'sale_doc1'){
        that.setState({
          sale_doc1_full: image_url,
          sale_doc_key1: sale_doc_key
        })
      } else if (input_file_name === 'sale_doc2') {
        that.setState({
          sale_doc2_full: image_url,
          sale_doc_key2: sale_doc_key
        })
      } else if (input_file_name === 'sale_doc3') {
        that.setState({
          sale_doc3_full: image_url,
          sale_doc_key3: sale_doc_key
        })
      } else if (input_file_name === 'sale_doc4') {
        that.setState({
          sale_doc4_full: image_url,
          sale_doc_key4: sale_doc_key
        })
      }

      if (!DocUtil.isImage(image_url)) {

        if( input_file_name === 'sale_doc1'){
          that.refs.img_sale_doc1.src = IMAGE_PDF_URL
        } else if (input_file_name === 'sale_doc2') {
          that.refs.img_sale_doc2.src = IMAGE_PDF_URL
        } else if (input_file_name === 'sale_doc3') {
          that.refs.img_sale_doc3.src = IMAGE_PDF_URL
        } else if (input_file_name === 'sale_doc4') {
          that.refs.img_sale_doc4.src = IMAGE_PDF_URL
        }
      } else {

        if( input_file_name === 'sale_doc1'){
          that.refs.img_sale_doc1.src = image_url
        } else if (input_file_name === 'sale_doc2') {
          that.refs.img_sale_doc2.src = image_url
        } else if (input_file_name === 'sale_doc3') {
          that.refs.img_sale_doc3.src = image_url
        } else if (input_file_name === 'sale_doc4') {
          that.refs.img_sale_doc4.src = image_url
        }
      }

      let img = new Image();
      img.src= image_url;
      img.addEventListener("load", function () {

      })
    })
      .catch(function(error){
        console.log('error:', error.response);
        // alert("error:"+error.response);
      });
  }

  loadCarSellById () {
    // alert (this.state.car_sell_id)

    axios.get(APIURL + '/car_sell/' + this.state.car_sell_id)
      .then(res => {
        if(this.mounted) {
          let car_sell = res.data[0]

          let image_url1 = ''
          let image_url2 = ''
          let image_url3 = ''
          let image_url4 = ''

          if (car_sell.sale_doc1 === null || car_sell.sale_doc1 === '') {
            image_url1 = IMAGE_NOPHOTO_URL
          } else {
            if (car_sell.sale_doc1.includes('https')) {
              image_url1 = car_sell.sale_doc1
            } else {
              image_url1 =  IMAGE_FULL_URL+car_sell.sale_doc1
            }
          }

          if (car_sell.sale_doc2 === null || car_sell.sale_doc2 === '') {
            image_url2 = IMAGE_NOPHOTO_URL
          } else {
            if (car_sell.sale_doc2.includes('https')) {
              image_url2 = car_sell.sale_doc2
            } else {
              image_url2 =  IMAGE_FULL_URL+car_sell.sale_doc2
            }
          }

          if (car_sell.sale_doc3 === null || car_sell.sale_doc3 === '') {
            image_url3 = IMAGE_NOPHOTO_URL
          } else {
            if (car_sell.sale_doc3.includes('https')) {
              image_url3 = car_sell.sale_doc3
            } else {
              image_url3 =  IMAGE_FULL_URL+car_sell.sale_doc3
            }
          }

          if (car_sell.sale_doc4 === null || car_sell.sale_doc4 === '') {
            image_url4 = IMAGE_NOPHOTO_URL
          } else {
            if (car_sell.sale_doc4.includes('https')) {
              image_url4 = car_sell.sale_doc4
            } else {
              image_url4 =  IMAGE_FULL_URL+car_sell.sale_doc4
            }
          }

          // let sale_doc1 = car_sell.sale_doc1 === null || car_sell.sale_doc1 === '' ? IMAGE_NOPHOTO_URL : IMAGE_THUMB_URL+car_sell.sale_doc1;
          // let sale_doc1_full = car_sell.sale_doc1 === null || car_sell.sale_doc1 === '' ? IMAGE_NOPHOTO_URL : IMAGE_FULL_URL+car_sell.sale_doc1;
          // let sale_doc2 = car_sell.sale_doc2 === null || car_sell.sale_doc2 === '' ? IMAGE_NOPHOTO_URL : IMAGE_THUMB_URL+car_sell.sale_doc2;
          // let sale_doc2_full = car_sell.sale_doc2 === null || car_sell.sale_doc2 === '' ? IMAGE_NOPHOTO_URL : IMAGE_FULL_URL+car_sell.sale_doc2;
          let vat_sell = car_sell.vat_sell
          let finance_commission = car_sell.finance_commission
          let car_external_commission = car_sell.car_external_commission
          let sales_commission = car_sell.sales_commission
          let additional_commission = car_sell.additional_commission
          let advertising_cost = car_sell.advertising_cost
          let delivery_fee = car_sell.delivery_fee
          let promotion_fee = car_sell.promotion_fee
          let finance_fee = car_sell.finance_fee
          let transfer_fee = car_sell.transfer_fee
          let agent_id = car_sell.agent_id
          let sell_finance_contract = car_sell.sell_finance_contract === null ? '-' : car_sell.sell_finance_contract

          console.log('car_sell.sell_comment=', car_sell.sell_comment)
          let sell_comment = car_sell.sell_comment === null ? '<span>-</span>' : car_sell.sell_comment
          // console.log('agent_id=', agent_id, typeof agent_id)

          this.setState({
            agent_id: agent_id,
            car_sell: car_sell,
            car_id : car_sell.car_id,
            sale_doc1: DocUtil.isImage(image_url1) ? image_url1 : IMAGE_PDF_URL,
            sale_doc1_full: image_url1,
            sale_doc_key1: car_sell.sale_doc_key1,
            //
            sale_doc2: DocUtil.isImage(image_url2) ? image_url2 : IMAGE_PDF_URL,
            sale_doc2_full: image_url2,
            sale_doc_key2: car_sell.sale_doc_key2,
            //
            sale_doc3: DocUtil.isImage(image_url3) ? image_url3 : IMAGE_PDF_URL,
            sale_doc3_full: image_url3,
            sale_doc_key3: car_sell.sale_doc_key3,
            //
            sale_doc4: DocUtil.isImage(image_url4) ? image_url4 : IMAGE_PDF_URL,
            sale_doc4_full: image_url4,
            sale_doc_key4: car_sell.sale_doc_key4,
            //
            vat_sell: vat_sell,
            finance_commission: finance_commission,
            car_external_commission: car_external_commission,
            sales_commission: sales_commission,
            additional_commission: additional_commission,
            advertising_cost: advertising_cost,
            delivery_fee: delivery_fee,
            promotion_fee: promotion_fee,
            finance_fee: finance_fee,
            transfer_fee: transfer_fee,
            sell_finance_contract: sell_finance_contract,
            sell_comment: sell_comment
          }, () => {
             this.loadDataCarSellPay()
             this.loadAgentByID(agent_id)
          })
        }
      }).catch(error => {
      //alert('error' + error)
        console.log (error)
      this.setState({car_sell: {}})
    })
  }

  loadAgentByID(agent_id) {

    if (agent_id !== 0) {
      let uri = APIURL + '/agent/id/' + agent_id;
      axios.get(uri).then(res => {
        let agent = res.data

        this.setState({
          agent_fullname: agent.agent_fullname,
          agent_mobile: agent.agent_mobile
        });

      }).catch(error => {
        console.log('error:', error)
      })
    } else {
      this.setState({
        agent_fullname: '-',
        agent_mobile: '-'
      });
    }

  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillUnmount() {
    this.mounted = false
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  componentDidMount () {
    const queryString = require('query-string')
    this.mounted = true
    let car_sell = queryString.parse(this.props.location.search)
    this.setState({car_sell_id: car_sell.car_sell_id}, () => {
      this.loadCarSellById();
      //this.loadCarSellListPayData();
    })

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillMount () {
    //const queryString = require('query-string');
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  loadDataCarSellPay () {
    if (this.state.car_sell.car_id === '' || this.state.car_sell.customer_id === '') {
      return
    }

    axios.get(APIURL + '/car_sell_pay/buy/' + this.state.car_sell.car_id + '/' + this.state.car_sell.customer_id)
      .then(res => {
        this.setState({car_sell_pay_list: res.data})
      }).catch(error => {
        console.log(error)
        this.setState({car_sell_pay_list: []})
    })
  }

  printOcpb(car_sell_pay) {
    var car_brance = car_sell_pay.branch_name
    var car_brance_address = car_sell_pay.branch_address
    var car_brance_tel = car_sell_pay.branch_tel
    var car_name = car_sell_pay.car_name //ยี่ห้อรถ
    var car_color_name = car_sell_pay.car_color_name //สี
    var car_license_plate_new = car_sell_pay.car_license_plate_new //ทะเบียนรถยนต์
    var car_province_name_new = car_sell_pay.province_name_new //จังหวัด

    var customer_name = this.state.car_sell.customer_name //ชื่อลูกค้า
    var customer_lastname = this.state.car_sell.customer_lastname //นามสกุลลูกค้า
    var customer_address = this.state.car_sell.customer_address //ที่อยู่ลูกค้า
    var customer_mobile = this.state.car_sell.customer_mobile //

    var date_pay = moment(car_sell_pay.date_pay).locale('th').format('LL') //วันที่ออกใบเสร็จหรือวันที่จ่าย
    var person_transaction = car_sell_pay.person_transaction //ผู้ออกใบเสร็จ
    var car_sell_list_pay = car_sell_pay.car_sell_list_pay_name //รายการที่จ่าย
    var sales_type = car_sell_pay.sales_type_name //รูปแบบการจ่าย
    var car_sell_pay_count = '฿'+car_sell_pay.car_sell_pay_count.toLocaleString();  //ยอดเงิน

    let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)

    var docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [ 25, 30, 25, 0 ],
      background: {image: 'book', width: 600},

      content: [
        { text: 'ใบเสร็จรับเงิน', style: 'bodyhead', lineHeight:1.3},
        {

          columns: [
            { width: '20%',
              text: '', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: '',
            },
            { width: '20%',
              text: 'เลขที่ใบเสร็จ', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: '..........',
            },

          ],

          columnGap: 20,
          lineHeight:1
        },
        {

          columns: [
            { width: '20%',
              text: '', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: '',
            },
            { width: '20%',
              text: 'วันที่ออกใบเสร็จ', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: date_pay,
            },

          ],

          columnGap: 20,
          lineHeight:1
        },
        {

          columns: [
            { width: '19%',
              text: 'ผู้ประกอบธุรกิจ', style: 'bodycompany'
            },
            { width: '81%', style: 'bodycompany',
              text: car_brance,
            },

          ],

          columnGap: 20,
          lineHeight:1
        },

        {
          columns: [
            { width: '19%',
              text: 'สถานที่ประกอบการ', style: 'bodycompany'
            },
            { width: '81%', style: 'bodycompany',
              text: car_brance_address,
            },

          ],

          columnGap: 20,
          lineHeight:1
        },

        {
          columns: [

            { width: '20%',
              text: 'เบอร์โทรศัพท์', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: car_brance_tel,
            },
            { width: '20%',
              text: 'ผู้พิมพ์ใบเสร็จ', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: person_transaction,
            },

          ],

          columnGap: 20,
          lineHeight:1.3
        },

        {
          columns: [
            { width: '20%',
              text: 'ชื่อ - นามสกุลลูกค้า', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: customer_name + '   ' + customer_lastname,
            },
            { width: '20%',
              text: 'เบอร์โทรศัพท์', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: customer_mobile,
            },

          ],

          columnGap: 20,
          lineHeight:1.2
        },

        {
          columns: [
            { width: '19%',
              text: 'ที่อยู่', style: 'bodycompany'
            },
            { width: '80%', style: 'bodycompany',
              text: customer_address,
            },

          ],

          columnGap: 20,
          lineHeight:1.2
        },

        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 2,
            widths: [ 40, 'auto', 100, 100 ],
            heights: [20, 30],

            body: [
              [ {text: 'ลำดับ', style: 'myCell'},
                {text: 'รายการ', style: 'myCell'},
                {text: 'ราคา/หน่วย', style: 'myCell'},
                {text: 'รวมราคา', style: 'myCell'} ],
              [ {text: '1', style: 'myCellDetail'},
                {text: car_sell_list_pay + '   '
                + car_name + '   '
                + 'สี' + car_color_name
                + '   '
                + 'ทะเบียนรถ   ' + car_license_plate_new
                + '   ' + car_province_name_new
                + '   รูปแบบการชำระเงิน  :  '  + sales_type , style: 'body'},
                {text: car_sell_pay_count,style: 'myCellPrice'},
                {text:car_sell_pay_count, style: 'myCellSumPrice'} ],
            ]
          },

          columnGap: 20,
        },

        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: [ '*',  100 ],
            heights: [20],

            body: [
              [ {text: 'รวมราคา', style: 'myCellSumText'}, {text:car_sell_pay_count, style: 'myCellSumCost'}],
            ]
          },

          columnGap: 20,
        },

        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: [ '*',  100 ],
            heights: [20],

            body: [
              [ {text: 'รวมราคาทั้งสิ้น   '  + moneyText, style: 'myCellSumTextCost' }, {text: car_sell_pay_count, style: 'myCellSumTextCostNum'}],
            ]
          },

          columnGap: 20,
          lineHeight:1
        },

        [{ text: '   '}, { text: '   '}, { text: '   '}, { text: '   '},{ text: '   '},{ text: '   '},{ text: '   '},
          { text: 'ใบเสร็จรับเงิน', style: 'bodyhead', lineHeight:1.3},
          {

            columns: [
              { width: '20%',
                text: '', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: '',
              },
              { width: '20%',
                text: 'เลขที่ใบเสร็จ', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: '..........',
              },

            ],

            columnGap: 20,
            lineHeight:1
          },
          {

            columns: [
              { width: '20%',
                text: '', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: '',
              },
              { width: '20%',
                text: 'วันที่ออกใบเสร็จ', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: date_pay,
              },

            ],

            columnGap: 20,
            lineHeight:1
          },
          {

            columns: [
              { width: '19%',
                text: 'ผู้ประกอบธุรกิจ', style: 'bodycompany'
              },
              { width: '81%', style: 'bodycompany',
                text: car_brance,
              },

            ],

            columnGap: 20,
            lineHeight:1
          },

          {
            columns: [
              { width: '19%',
                text: 'สถานที่ประกอบการ', style: 'bodycompany'
              },
              { width: '81%', style: 'bodycompany',
                text: car_brance_address,
              },

            ],

            columnGap: 20,
            lineHeight:1
          },

          {
            columns: [

              { width: '20%',
                text: 'เบอร์โทรศัพท์', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: car_brance_tel,
              },
              { width: '20%',
                text: 'ผู้พิมพ์ใบเสร็จ', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: person_transaction,
              },

            ],

            columnGap: 20,
            lineHeight:1.3
          },

          {
            columns: [
              { width: '20%',
                text: 'ชื่อ - นามสกุลลูกค้า', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: customer_name + '   ' + customer_lastname,
              },
              { width: '20%',
                text: 'เบอร์โทรศัพท์', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: customer_mobile,
              },

            ],

            columnGap: 20,
            lineHeight:1.2
          },

          {
            columns: [
              { width: '19%',
                text: 'ที่อยู่', style: 'bodycompany'
              },
              { width: '80%', style: 'bodycompany',
                text: customer_address,
              },

            ],

            columnGap: 20,
            lineHeight:1.2
          },

          {
            table: {
              headerRows: 2,
              widths: [ 40, 'auto', 100, 100 ],
              heights: [20, 30],
              body: [
                [ {text: 'ลำดับ', style: 'myCell'},
                  {text: 'รายการ', style: 'myCell'},
                  {text: 'ราคา/หน่วย', style: 'myCell'},
                  {text: 'รวมราคา', style: 'myCell'} ],
                [ {text: '1', style: 'myCellDetail'},
                  {text: car_sell_list_pay + '   '
                  + car_name + '   '
                  + 'สี' + car_color_name
                  + '   '
                  + 'ทะเบียนรถ   ' + car_license_plate_new
                  + '   ' + car_province_name_new
                  + '   รูปแบบการชำระเงิน  :  ' + sales_type , style: 'body'},
                  {text: car_sell_pay_count,style: 'myCellPrice'},
                  {text:car_sell_pay_count, style: 'myCellSumPrice'} ],
              ]
            },
            columnGap: 20,
          },

          {
            table: {
              headerRows: 1,
              widths: [ '*',  100 ],
              heights: [20],
              body: [
                [ {text: 'รวมราคา', style: 'myCellSumText'}, {text:car_sell_pay_count, style: 'myCellSumCost'}],
              ]
            },
            columnGap: 20,
          },

          {
            table: {
              headerRows: 1,
              widths: [ '*',  100 ],
              heights: [20],
              body: [
                [ {text: 'รวมราคาทั้งสิ้น   '  + moneyText, style: 'myCellSumTextCost' }, {text: car_sell_pay_count, style: 'myCellSumTextCostNum'}],
              ]
            },
            columnGap: 20,
            lineHeight:1
          },
        ],
      ],
      images:{
        book:'data:image/png;base64,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'
      },

      styles: {
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 14,
          fillColor: '#BEBEBE',
          alignment: 'center',
          bold: true,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: 'center',
        },
        myCellPrice: {
          fontSize: 14,
          alignment: 'right',
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: 'right',
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: '#D3D3D3',
          alignment: 'left',
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: '#D3D3D3',
          alignment: 'right',
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: '#FF9933',
          alignment: 'left',
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: '#FF9933',
          alignment: 'right',
          bold: true,
        },
      },
      defaultStyle: {
        font: 'THSarabunNew'
      }
    };
    pdfMake.createPdf(docDefinition).open();
  }

  async carSellPayEdit(car_sell_pay){

    await this.loadSalesTypeData()
    await this.loadBankData()

    await axios.get(APIURL + '/car_sell_list_pay/')
      .then(res => {
        //set data edit to form
        //alert('car_sell_pay.date_pay='+car_sell_pay.date_pay); return;

        if(this.mounted) {
          this.setState({
            car_sell_list_pay: res.data,
            car_sell_pay_selected: car_sell_pay,
            date_pay: new Date(car_sell_pay.date_pay), //moment().format('YYYY-MM-DD'),
            car_sell_list_pay_id: car_sell_pay.car_sell_list_pay_id,
            car_sell_pay_count_old: car_sell_pay.car_sell_pay_count,
            car_sell_pay_count: car_sell_pay.car_sell_pay_count,
            sales_type_id: car_sell_pay.sales_type_id,
            car_sell_pay_id: car_sell_pay.car_sell_pay_id,
            bank_id: car_sell_pay.bank_id,
          }, () => {
            this.toggleCarSellPayEdit();
          })
        }

      }).catch(error => {
         this.setState({car_sell_list_pay: []});
      })
  }

  async loadSalesTypeData () {
   await axios.get(APIURL + '/sales_type/')
      .then(res => {
        if(this.mounted) {
          this.setState({sales_type: res.data})
        }

      }).catch(error => {
       if(this.mounted) {
         this.setState({ sales_type: [] })
       }
    })
  }

  async loadBankData () {
    await axios.get(APIURL + '/bank/')
      .then(res => {
        if(this.mounted) {
          this.setState({ bank: res.data })
        }
      }).catch(error => {
      this.setState({bank: []})
    })
  }

  async carSellPayAdd() {
    await this.loadSalesTypeData()
    await this.loadBankData()

    await axios.get(APIURL + '/car_sell_list_pay/')
      .then(res => {
        if(this.mounted) {
          this.setState({
            car_sell_list_pay: res.data
          })
        }
      }).catch(error => {
        if(this.mounted) {
          this.setState({ car_sell_list_pay: [] });
        }
      })

    this.toggleCarSellPayAdd();
    // this.loadCarSellById();

  }

  toggleCarSellEdit () {
    this.setState({
      primary: !this.state.primary
    })
  }

  toggleCarSellPriceEdit () {
    this.setState({
      toggle_sell_price: !this.state.toggle_sell_price
    })
  }

  toggleCarSellPayAdd() {
    this.setState({
      toggle_pay_add: !this.state.toggle_pay_add
    })
  }

  toggleCarSellPayEdit () {
    this.setState({
      toggle_car_sell_pay_edit: !this.state.toggle_car_sell_pay_edit
    })
  }

  handleDatePay(date) {
    this.setState({
      date_pay: date
    });
  }

  carSalesPayTypeChange (obj){
    let value = obj.target.value

    this.setState({sales_type_id: value}, ()=>{
      if (value === '1') {
        this.refs.bank_id.value = '1'
      } else {
        this.refs.bank_id.value = ''
      }
    });
  }

  loadCarSellListPayData () {
    axios.get(APIURL + '/car_sell_list_pay/')
      .then(res => {
        this.setState({car_sell_list_pay: res.data})
      }).catch(error => {
      this.setState({car_sell_list_pay: []})
    })
  }

  handleCarSellPayEditSubmit(event){
    event.preventDefault();
    var car_sell_pay_id = event.target.car_sell_pay_id.value
    var date_pay = event.target.date_pay.value
    var car_sell_list_pay_id = event.target.car_sell_list_pay_id.value
    var car_sell_pay_count = event.target.car_sell_pay_count.value // ยอดใหม่ที่กรอก
    var sales_type_id = event.target.sales_type_id.value
    var bank_id = event.target.bank_id.value

    var car_sell_id = this.state.car_sell_id;
    var balance_debt_current = this.state.car_sell.balance_debt // ยอดหนี้คงเหลือปัจุบัน in db
    var car_sell_pay_count_old = this.state.car_sell_pay_count_old // ยอดเดิม
    var car_sell_pay_count_diff = Number(car_sell_pay_count) - Number(car_sell_pay_count_old) // ส่วนต่าง

    var balance_debt = Number(balance_debt_current) - Number(car_sell_pay_count_diff)

    var data = {
      date_pay: date_pay,
      car_sell_list_pay_id: car_sell_list_pay_id,
      car_sell_pay_count: car_sell_pay_count,
      sales_type_id: sales_type_id,
      bank_id: bank_id,
      user_updated: this.state.user.user,
      //for car_sell
      car_sell_id: car_sell_id,
      balance_debt: balance_debt
    }

    // update data การจ่ายเงิน
      axios.put(APIURL+ '/car_sell_pay/'+car_sell_pay_id, data)
      .then(res => {
        if (res.status === 200) {
          //load new pay list
          this.setState({
            toggle_car_sell_pay_edit: !this.state.toggle_car_sell_pay_edit
          },()=>{
            this.loadCarSellById();
            // this.loadDataCarSellPay()
          });

        }
      });


  }

  handleCarSellPayAddSubmit(event) {
    event.preventDefault();
    // var car_sell_pay_id = event.target.car_sell_pay_id.value
    var date_pay = event.target.date_pay.value
    var car_sell_list_pay_id = event.target.car_sell_list_pay_id.value
    var car_sell_pay_count = event.target.car_sell_pay_count.value // ยอดใหม่ที่กรอก
    var sales_type_id = event.target.sales_type_id.value
    var bank_id = event.target.bank_id.value

    var car_sell_id = this.state.car_sell_id;
    var balance_debt_current = this.state.car_sell.balance_debt // ยอดหนี้คงเหลือปัจุบัน in db
    var car_sell_pay_count_old = this.state.car_sell_pay_count_old // ยอดเดิม
    var car_sell_pay_count_diff = Number(car_sell_pay_count) - Number(car_sell_pay_count_old) // ส่วนต่าง
    var balance_debt = Number(balance_debt_current) - Number(car_sell_pay_count_diff)

    let person_transaction = this.state.user.user
    let customer_id = this.state.car_sell.customer_id
    let car_id = this.state.car_sell.car_id

   /* var data = {
      date_pay: date_pay,
      car_sell_list_pay_id: car_sell_list_pay_id,
      car_sell_pay_count: car_sell_pay_count,
      sales_type_id: sales_type_id,
      bank_id: bank_id,
      user_updated: this.state.user.user,
      //for car_sell
      car_sell_id: car_sell_id,
      balance_debt: balance_debt
    } */

   let data = {
     car_id: car_id,
     customer_id: customer_id,
     date_pay: date_pay,
     car_sell_list_pay_id: car_sell_list_pay_id,
     car_sell_pay_count: car_sell_pay_count,
     sales_type_id: sales_type_id,
     bank_id: bank_id,
     person_transaction: person_transaction,
     user_created: this.state.user.user,
     user_updated: this.state.user.user,
     //for car_sell
     car_sell_id: car_sell_id,
     balance_debt: balance_debt
   }

    //add การจ่ายเงิน
    axios.post(APIURL + '/car_sell_pay/history', data)
      .then(res => {

        if (res.status === 200) {
          //load new pay list
          this.setState({
            toggle_pay_add: !this.state.toggle_pay_add,
            car_sell : {}
          },()=>{

            this.loadCarSellById();
            // this.loadDataCarSellPay()
          });

        }

      })
      .catch(function (error) {
        console.log(error)
        alert('พบข้อผิดพลาด: ' + error)
      })

  }

  convertLicenseIdToName(liciense_status_id) {
    switch (liciense_status_id) {
      case 1:
        return 'มีเล่มทะเบียน';
      case 2:
        return 'ยังไม่ปิดบัญชี';
      case 3:
        return 'เล่มรอปิดบัญชี';
      case 4:
        return 'มีเล่มอยู่เต็นท์';
      default:
        return '-'
    }
  }

  saveCarImage(e,urlImage){
    e.preventDefault();
    let a = document.createElement('a');
    a.href = urlImage;
    a.target = '_blank';
    a.download = urlImage;
    a.click();
    a.remove();
    return false;
  }

  refundCarBook (car_sell_pay) {
    //alert(car_sell_pay.car_book_id )
    this.setState({
      car_sell_pay_id: car_sell_pay.car_sell_pay_id,
      car_sell_pay_count: car_sell_pay.car_sell_pay_count,
      car_sell_pay_selected: car_sell_pay
    }, () => {
      this.toggleRefund()
    })
  }

  toggleRefund () {
    this.setState({
      refund: !this.state.refund
    })
  }

  carPayRefund() {
    // var book_rows = 0
    // var car_id = this.state.car_id
    let car_sell_pay_id = this.state.car_sell_pay_id
    let car_sell_pay_count = this.state.car_sell_pay_count
    // var car_book_id = this.state.car_sell_pay_selected.car_book_id
    let car_book_refund = Number(this.state.car_book_refund)

    let data = {
      car_sell_pay_id: car_sell_pay_id,
      car_sell_pay_count: car_sell_pay_count,
      car_book_refund: car_book_refund
    }

    if (car_book_refund === 0) {
      alert('กรุณากรอกยอดคืนเงิน')
      return
    }

    if (car_book_refund > car_sell_pay_count) {
      alert('ยอดเงินคืนมากกว่ายอดชำระ กรุณาตรวจสอบ')
      return
    }

    axios.post(APIURL + '/car_sell/refund', data).then(res => {

      let result = res.data.result
      if (result === 'success') {
        AlertSuccess('บันทึกการคืนเงินเรียบร้อยแล้ว');
        this.loadCarSellById()
        this.toggleRefund()
      }
    })
  }

  deleteCarPay(car_sell_pay) {
    // console.log(car_sell_pay)
    var car_sell_pay_count = car_sell_pay.car_sell_pay_count

    Swal.fire({
      title: 'ยืนยันการลบรายการ '+ car_sell_pay_count.toLocaleString()+' บาท' + ' ใช่หรือไม่ ? ',
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        var car_sell_pay_id = car_sell_pay.car_sell_pay_id
        this.setState({car_sell:{}},()=>{
          axios.delete(APIURL+'/car_sell_pay/'+car_sell_pay_id)
              .then(res => {
                this.loadCarSellById();
                //this.loadDataCarSellPay()
              })
        })
      }
    })
  }

  // TODO: edit agent
  toggleAgentModal(status, agent) {
    this.setState({
      isAgentModal: status
    })

    if(agent !== null) {
      const agent_id = this.state.agent_id
      const agent_id_new = agent.agent_id
      const agent_fullname = agent.agent_fullname
      const agent_mobile = agent.agent_mobile

      if (agent_id !== agent_id_new) {
        Swal.fire({
          title: 'ยืนยันการเปลี่ยนนายหน้าเป็น  ' + agent_fullname + ' ใช่หรือไม่ ? ',
          icon: 'warning',
          showConfirmButton: true,
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {

            let data = {
              car_sell_id: this.state.car_sell_id,
              agent_id: agent_id_new,
            }

            let url = APIURL + '/car_sell/agent'
            axios.put( url, data).then(res => {
              if(res.data === 'success') {
                AlertSuccess('แก้ไขข้อมูลเรียบร้อยแล้ว')
                this.setState({
                  agent_id: agent_id_new,
                  agentSelected: agent,
                  agent_fullname: agent_fullname,
                  agent_mobile: agent_mobile
                })
              }
            }).catch(error => {
              console.log('error:', error)
            })

          }
        })
      }

    }
  }


  render () {
    let car_sell = this.state.car_sell

    let width = this.state.width
    let car_sell_pay_tr = this.state.car_sell_pay_list.map((car_sell_pay, index) => {
      return (
        <tr key={index}>
          <td className="text-center">{car_sell_pay.date_pay}</td>
          <td className="text-center">{car_sell_pay.car_sell_list_pay_name}</td>
          <td className="text-center">

            {car_sell_pay.car_sell_pay_refund > 0 ? (
              <>
                ชำระ: <NumberFormat value={car_sell_pay.car_sell_pay_count}
                                    displayType={'text'} thousandSeparator={true}
                                    prefix={'฿'}
              />
                <span className="badge" style={{backgroundColor: '#f86c6b'}}>
                เงินคืน: &nbsp;
                  <NumberFormat value={car_sell_pay.car_sell_pay_refund}
                                displayType={'text'}
                                thousandSeparator={true} prefix={'฿'}/>
              </span>
              </>
            ) : <NumberFormat value={car_sell_pay.car_sell_pay_count}
                              displayType={'text'} thousandSeparator={true}
                              prefix={'฿'}
            />}

          </td>
          <td className="text-center">{car_sell_pay.sales_type_name}</td>
          <td className="text-center">{car_sell_pay.bank_name}</td>
          <td className="text-center">
            {car_sell_pay.person_transaction}
            <br/>
            {moment(car_sell_pay.updated_at).locale('th').format('DD-MM-YYYY HH:mm:ss')}
          </td>
          <td className="text-center">
            <button onClick={() => {
                this.carSellPayEdit(car_sell_pay)
            }}
              type="button" className="btn btn-warning btn-sm btn-block">
              <i className="icon-pencil">&nbsp; แก้ไข</i>
            </button>

            <button onClick={() => {
                this.printOcpb(car_sell_pay)
            }}
              type="button" className="btn btn-success btn-sm btn-block">
              <i className="icon-printer">&nbsp; พิมพ์</i>
            </button>

            <button onClick={() => {
              this.refundCarBook(car_sell_pay)
            }}
                    type="button" className="btn btn-primary btn-sm btn-block">
              <i className="icon-wallet">&nbsp;คืนเงิน</i>
            </button>

            <button onClick={() => {
              this.deleteCarPay(car_sell_pay)
            }}
                    type="button" className="btn btn-danger btn-sm btn-block">
              <i className="icon-trash">&nbsp;ลบ</i>
            </button>

          </td>
        </tr>
      )
    })

    let car_sell_list_pay_list = this.state.car_sell_list_pay.map((car_sell_list_pay, index) => {
      return (
        <option key={index}
                value={car_sell_list_pay.car_sell_list_pay_id}
        >
          {car_sell_list_pay.car_sell_list_pay_name}
        </option>
      )
    })

    let sales_type_list = this.state.sales_type.map((sales_type, index) => {
      return (
        <option key={index} value={sales_type.sales_type_id}>{sales_type.sales_type_name}</option>
      )
    });

    let bank_pay_list = this.state.bank.map((bank, index) => {
      return (
        <option key={index} value={bank.bank_id}>{bank.bank_name}</option>
      )
    })

    return (
      <div className="col-md-12 mb-4">

        <Modal isOpen={this.state.refund} toggle={this.toggleRefund.bind(this)}
               className={'modal-danger'}>
          <ModalHeader toggle={this.toggleRefund.bind(this)}>คืนเงินลูกค้า</ModalHeader>
          <ModalBody>
            <div className="card-block">
              <div className="row">
                <div className="row p-5">
                  <div className="form-group col-sm-6">
                    <strong>ยอดเงินที่ชำระ :</strong>
                  </div>
                  <div className="form-group col-sm-6">
                    <input type="text" className="form-control"
                           ref="car_sell_pay_count"
                           value={this.state.car_sell_pay_count}
                           onChange={() => {}}
                    />
                  </div>

                  <div className="form-group col-sm-6">
                    <strong>ยอดคืนเงิน :</strong>
                  </div>

                  <div className="form-group col-sm-6">
                    <input type="text"
                           className="form-control hidden"
                           name="car_book_refund"
                           placeholder=""
                           ref="car_book_refund"
                           value={this.state.car_book_refund}
                           onChange={() => {}}
                    />
                    <NumberFormat
                      className="form-control"
                      thousandSeparator={true}
                      prefix={'฿'}
                      placeholder="คืนเงิน"
                      min={0}
                      max={1000000000}
                      step={1000}
                      size={10}
                      allowNegative={false}
                      onValueChange={(values) => {
                        const {value} = values
                        this.setState({car_book_refund: value})

                      }}
                    />
                  </div>

                </div>
              </div>
            </div>

          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggleRefund.bind(this)}>ยกเลิก</Button>
            <Button color="primary"
                    onClick={this.carPayRefund.bind(this)}>ตกลง</Button>{' '}

          </ModalFooter>
        </Modal>

        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === '1'})}
              onClick={() => { this.toggle('1') }}
            >
              <i className="icon-options-vertical"/> ข้อมูลการขายรถ
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">ข้อมูลการขายรถ</strong>
                    <Button type="button" onClick={this.toggleCarSellEdit}
                            className="btn btn-warning float-right">
                      <i className="icon-note"/>&nbsp;&nbsp;แก้ไขข้อมูลการขาย
                    </Button>

                    <AgentModal
                      isAgentModal={this.state.isAgentModal}
                      toggleAgentModal = {this.toggleAgentModal}
                    />

                    <Modal isOpen={this.state.primary} toggle={this.toggleCarSellEdit}
                           className={'modal-lg ' + this.props.className}
                           style={width<=980 ?{maxWidth:800}:{maxWidth:1200}}
                    >
                      <ModalBody>
                        <SalesEdit
                          onToggle={this.toggleCarSellEdit}
                          onLoadCarSellById={() => {
                             // this.loadCarSellById()
                             window.location.reload(false);
                          }}
                          car_sell={this.state.car_sell}

                        />
                      </ModalBody>
                    </Modal>

                    <Modal isOpen={this.state.toggle_sell_price} toggle={this.toggleCarSellPriceEdit}
                           className={'modal-lg ' + this.props.className}
                           style={width<=980 ?{maxWidth:800}:{maxWidth:1200}}>
                      <ModalBody>
                        <SalesPriceEdit
                          onToggle={this.toggleCarSellPriceEdit}
                          onLoadCarSellById={() => {
                            this.loadCarSellById()
                          }}
                          car_sell={this.state.car_sell}/>
                      </ModalBody>
                    </Modal>

                  </div>

                  <div className="card-block">

                    <div className="row">
                      <div className="col-lg-12">

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 ">
                            <strong> ยี่ห้อ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_brand_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> รุ่นรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_model_name} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> รุ่นย่อย </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_sub_model_name} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> ปีรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_year_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> ระบบเกียร์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_gear_name} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> สีรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_color_name} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> เลขไมล์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_miles}  </strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> ป้ายทะเบียนรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_license_plate_new} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> จังหวัด </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.province_name_new} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-3 "><strong> สถานะ </strong></label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_status_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-3"><strong> วันที่ทำสัญญา/นัด </strong></label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {moment(car_sell.date_promise).locale('th').format('LL')} </strong>
                            </p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-3 "><strong> ชื่อลูกค้า </strong></label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.customer_name}</strong>
                            </p>
                          </div>

                          <label className="col-md-3"><strong> นามสกุลลูกค้า </strong></label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.customer_lastname} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-3"><strong> เลขประจำตัวประชาชน </strong></label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.customer_card_id} </strong></p>
                          </div>

                          <label className="col-md-3 "><strong> เบอร์โทรศัพท์ </strong></label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.customer_mobile} </strong>
                            </p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-3"><strong> ที่อยู่ปัจจุบัน </strong></label>
                          <div className="col-md-9">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.customer_address} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> ประเภทการขาย </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.car_sell_type_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> ไฟแนนซ์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.bank_finance_name_new} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> ชื่อพนักงานไฟแนนซ์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.sell_finance_contract===null? '-' : car_sell.sell_finance_contract} </strong></p>
                          </div>

                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> ราคาปกติ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.normal_sell_price}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> ราคาขายจริง </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.real_sell_price}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>
                          </div>

                          <label className="col-md-2"><strong> ส่วนลด </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.car_sell_discount}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> ยอดจัดไฟแนนซ์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.rate_finance}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong>
                            </p>
                          </div>

                          {/*<label className="col-md-2"><strong> ประกัน PA </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.insurance_pa}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>
                          </div>*/}

                          <label className="col-md-2"><strong> รวมมูลค่ายอดจัด </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.total_rate_finance}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>
                          </div>

                          <label className="col-md-2"><strong> ส่วนลดเงินดาวน์ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.sell_discount}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>
                          </div>

                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> ยอดดาวน์คงเหลือ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.sum_down} displayType={'text'}
                                                    thousandSeparator={true} prefix={'฿'}/></strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> บริษัทประกัน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.insurance_company_name} </strong></p>
                          </div>

                          <label className="col-md-2"><strong> ประเภทประกัน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.insurance_type_name} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> ราคาประกัน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.insurance_price}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong>
                            </p>
                          </div>

                          <label className="col-md-2 hidden"><strong> ค่าจัดไฟแนนซ์/ค่าโอน </strong></label>
                          <div className="col-md-2 hidden">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                    value={car_sell.cost_finance}
                                    displayType={'text'} thousandSeparator={true} prefix={'฿'}
                                />
                              </strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> การซื้อประกัน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.insurance_buy} </strong></p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>

                          <label className="col-md-2 "><strong> เก็บค่าประกันชีวิต PA </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                   value={car_sell.insurance_pa}
                                   displayType={'text'}
                                   thousandSeparator={true}
                                   prefix={'฿'}
                                />
                              </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong> เก็บค่างวดรถล่วงหน้า </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                  value={car_sell.pay_advance_finance}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'฿'}
                                />
                              </strong>
                            </p>
                          </div>

                        </div>

                        {/* <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong>
                            ค่างวดล่วงหน้า/เดือน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.cost_period_month}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> จำนวนงวด </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.count_period_name} </strong></p>
                          </div>

                          <label className="col-md-2"><strong>
                            รวมค่างวดที่เรียกเก็บ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.total_cost_period_call}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>
                          </div>
                        </div> */}

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> ระยะเวลาผ่อนชำระ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.duration_period_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-2"><strong> รวมออกรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                   <NumberFormat
                                        value={car_sell.total_outof_car}
                                        displayType={'text'} thousandSeparator={true}
                                        prefix={'฿'}/>
                              </strong>
                            </p>
                          </div>

                          {/*<label className="col-md-2"><strong> คงเหลือค้างชำระ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.balance_debt}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>
                          </div>*/}

                          <label className="col-md-2"><strong> คงเหลือค้างชำระ </strong></label>
                          <div className="col-md-2">
                            {/*<p className="text-justify text-primary">
                              <strong><NumberFormat value={car_sell.total_outof_car - car_sell.balance_debt}
                                                    displayType={'text'} thousandSeparator={true}
                                                    prefix={'฿'}/></strong></p>*/}
                            <strong>
                            {Object.keys(car_sell).length  !== 0? (<OutstandingBalanceComponent
                                car_id={car_sell.car_id}
                                customer_id={car_sell.customer_id}
                                balance_debt={car_sell.balance_debt}
                                bank_finance_id={car_sell.bank_finance_id}
                                car_sell={car_sell}
                                isShowText={false}
                            />): null}
                            </strong>


                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine} >
                          <label className="col-md-2 "><strong> ชื่อโปรโมชั่น </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong> {car_sell.promotion_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong> ยอดขายเกิน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat value={car_sell.car_over_sales}
                                              displayType={'text'} thousandSeparator={true}
                                              prefix={'฿'}/>
                               </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong> ยอดจัดเกิน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat value={car_sell.car_excess_amount}
                                              displayType={'text'} thousandSeparator={true}
                                              prefix={'฿'}/>
                                </strong>
                            </p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine} >

                          {/*<label className="col-md-2 "><strong> ค่านายหน้า </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat value={car_sell.car_external_commission}
                                              displayType={'text'} thousandSeparator={true}
                                              prefix={'฿'}/>
                                </strong>
                            </p>
                          </div>*/}

                          <label className="col-md-2 "><strong> เงินคืนลูกค้า </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-success">
                              <strong>
                                <NumberFormat value={car_sell.customer_cash}
                                              displayType={'text'} thousandSeparator={true}
                                              prefix={'฿'}/>
                                </strong>
                            </p>
                          </div>

                        </div>

                        <div className=" form-group row" style={styles.bottomLine} >

                          {/*<label className="col-md-2 "><strong> ค่าประกันชีวิต </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat value={car_sell.insurance_pa}
                                              displayType={'text'} thousandSeparator={true}
                                              prefix={'฿'}
                                />
                              </strong>
                            </p>
                          </div>*/}

                          <label className="col-md-2 "><strong> ค่างวดรถต่อเดือน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat value={car_sell.monthly_installment}
                                              displayType={'text'}
                                              thousandSeparator={true}
                                              prefix={'฿'}
                                />
                              </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong> รวมยอดผ่อน </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat value={car_sell.total_installment}
                                              displayType={'text'} thousandSeparator={true}
                                              prefix={'฿'}
                                />
                              </strong>
                            </p>
                          </div>

                        </div>

                        <div className=" form-group row" style={styles.bottomLine} >
                          <label className="col-md-2 "><strong> งวดแรก(วันที่)  </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>

                                {car_sell.first_installment!=='0000-00-00'? moment(car_sell.first_installment).locale('th').format('LL') : '-'}
                              </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong> ดอกเบี้ยต่อปี  </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                <NumberFormat
                                  value={car_sell.interest_installment}
                                  displayType={'text'} thousandSeparator={true}
                                  prefix={'%'}
                                  fixedDecimalScale={true}
                                />
                              </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong> วันที่ออกรถ/ปล่อยรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                                <strong>
                                {  car_sell.car_issue_date!=='0000-00-00'? moment(car_sell.car_issue_date).locale('th').format('LL') : '-'}
                              </strong>
                            </p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>
                          <label className="col-md-2 "><strong> สถานะเล่ม  </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                {this.convertLicenseIdToName(car_sell.liciense_status_id)}
                              </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong>วันที่โอนรถ/รับรถ </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                {  car_sell.car_transfer_date!=='0000-00-00'? moment(car_sell.car_transfer_date).locale('th').format('LL') : '-'}
                              </strong>
                            </p>
                          </div>

                          <label className="col-md-2 "><strong> วันที่รับเงิน(ไฟแนนซ์)  </strong></label>
                          <div className="col-md-2">
                            <p className="text-justify text-primary">
                              <strong>
                                {  car_sell.finance_payment_date!=='0000-00-00'? moment(car_sell.finance_payment_date).locale('th').format('LL') : '-'}
                              </strong>
                            </p>
                          </div>
                        </div>

                        <div className=" form-group row" style={styles.bottomLine}>

                          <div className="form-group col-sm-3">
                            <label htmlFor="name">1) เอกสาร 1 ภาพ pdf doc ฯ
                              &nbsp;
                              <a rel="noopener noreferrer"
                                 href={this.state.sale_doc1_full}
                                 target="_blank"
                                 onClick={(e)=>this.saveCarImage(e,this.state.sale_doc1_full)}
                                 className={this.state.sale_doc1_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}>
                                <span>donwload</span>
                              </a>
                            </label>
                            <div style={styles.fileInputWrapper} >

                              <button style={styles.btnFileInput}>
                                <img src={this.state.sale_doc1}
                                     style={styles.btnFileInputImage}
                                     ref="img_sale_doc1"
                                     alt="เอกสาร 1 ภาพ pdf doc ฯ"
                                />
                              </button>
                              <input
                                style={styles.fileInput}
                                type="file"
                                name="sale_doc1"
                                onChange={this.handleUploadFile}
                              />
                            </div>
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="name">2) เอกสาร 2 ภาพ pdf doc ฯ
                              &nbsp;
                              <a rel="noopener noreferrer"
                                 href={this.state.sale_doc2_full}
                                 target="_blank"
                                 onClick={(e)=>this.saveCarImage(e,this.state.sale_doc2_full)}
                                 className={this.state.sale_doc2_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}>
                                <span>donwload</span>
                              </a>
                            </label>
                            <div style={styles.fileInputWrapper} >
                              <button style={styles.btnFileInput}>
                                <img src={this.state.sale_doc2}
                                     style={styles.btnFileInputImage}
                                     ref="img_sale_doc2"
                                     alt="เอกสาร 2 ภาพ pdf doc ฯ"
                                />
                              </button>
                              <input
                                style={styles.fileInput}
                                type="file" name="sale_doc2"
                                onChange={this.handleUploadFile}
                              />
                            </div>
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="name">3) เอกสาร 3 ภาพ pdf doc ฯ
                              &nbsp;
                              <a rel="noopener noreferrer"
                                 href={this.state.sale_doc3_full}
                                 target="_blank"
                                 onClick={(e)=>this.saveCarImage(e,this.state.sale_doc3_full)}
                                 className={this.state.sale_doc3_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}>
                                <span>donwload</span>
                              </a>
                            </label>
                            <div style={styles.fileInputWrapper} >
                              <button style={styles.btnFileInput}>
                                <img src={this.state.sale_doc3}
                                     style={styles.btnFileInputImage}
                                     ref="img_sale_doc3"
                                     alt="เอกสาร 3 ภาพ pdf doc ฯ"
                                />
                              </button>
                              <input
                                style={styles.fileInput}
                                type="file" name="sale_doc3"
                                onChange={this.handleUploadFile}
                              />
                            </div>
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="name">4) เอกสาร 4 ภาพ pdf doc ฯ
                              &nbsp;
                              <a rel="noopener noreferrer"
                                 href={this.state.sale_doc4_full}
                                 target="_blank"
                                 onClick={(e)=>this.saveCarImage(e,this.state.sale_doc4_full)}
                                 className={this.state.sale_doc4_full===IMAGE_NOPHOTO_URL? 'hidden' : ''}>
                                <span>donwload</span>
                              </a>
                            </label>
                            <div style={styles.fileInputWrapper} >
                              <button style={styles.btnFileInput}>
                                <img src={this.state.sale_doc4}
                                     style={styles.btnFileInputImage}
                                     ref="img_sale_doc4"
                                     alt="เอกสาร 4 ภาพ pdf doc ฯ"
                                />
                              </button>
                              <input
                                style={styles.fileInput}
                                type="file" name="sale_doc4"
                                onChange={this.handleUploadFile}
                              />
                            </div>
                          </div>


                        </div>

                      </div>
                    </div>

                    <div className="row" style={styles.bottomLineAndMargin}>
                      <div className="form-group col-sm-2">
                        <h6>นายหน้า</h6>
                      </div>
                      <div className="form-group col-sm-4">
                        <label htmlFor="agent_fullname">ชื่อ-นามสกุลนายหน้า</label>
                        <input type="text"
                               className="form-control"
                               name="agent_fullname"
                               placeholder=""
                               value={this.state.agent_fullname}
                               onChange={() => {}}
                        />
                      </div>
                      <div className="form-group col-sm-4">
                        <label htmlFor="agent_mobile">เบอร์โทร</label>
                        <input type="text"
                               className="form-control"
                               name="agent_mobile"
                               placeholder=""
                               value={this.state.agent_mobile}
                               onChange={() => {}}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <Button type="button" onClick={() => this.toggleAgentModal(true, null)}
                                className="btn btn-warning float-right">
                          <i className="icon-note"/>&nbsp;&nbsp;แก้ไขนายหน้า
                        </Button>
                      </div>
                    </div>

                    <div className="row" style={styles.bottomLineAndMargin}>
                      <div className="form-group col-sm-2">
                        <h6>ค่าใช้จ่ายการขาย</h6>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="car_external_commission">ค่านายหน้า</label>
                        {/*<input type="text"
                               className="form-control hidden"
                               id="car_external_commission"
                               name="car_external_commission"
                               placeholder=""
                               ref="car_external_commission"
                               value={this.state.car_external_commission}
                               onChange={()=>{}}
                        />*/}
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          value={this.state.car_external_commission}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="sales_commission">ค่าคอมมิชชั่นฝ่ายขาย</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.sales_commission}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="additional_commission">ค่าคอมมิชชั่นเพิ่มเติม</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.additional_commission}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="advertising_cost">ค่าโฆษณา</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.advertising_cost}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="delivery_fee">ค่าบริการส่งรถ</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.delivery_fee}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        &nbsp;
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="promotion_fee">ค่าโปรโมชั่น</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.promotion_fee}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="finance_fee">ค่าธรรมเนียมไฟแนนท์</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.finance_fee}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="transfer_fee">ค่าโอนรถ</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.transfer_fee}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                    </div>

                    <div className="row" style={styles.bottomLineAndMargin}>
                      <div className="form-group col-sm-2">
                        <h6>รายรับการขาย</h6>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="vat_sell">vat ยอดจัดได้คืน</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.vat_sell}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="finance_commission">ค่าคอมมิชชั่นไฟแนนท์</label>
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          value={this.state.finance_commission}
                          displayType={'text'}
                          prefix={'฿'}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                        />
                      </div>

                      <div className="form-group col-sm-2"> &nbsp; </div>
                      <div className="form-group col-sm-2"> &nbsp; </div>
                      <div className="form-group col-sm-2">
                        <Button type="button" onClick={this.toggleCarSellPriceEdit}
                                className="btn btn-warning float-right">
                          <i className="icon-note"/>&nbsp;&nbsp;แก้ไขรับ-จ่ายการขาย
                        </Button>
                      </div>

                    </div>


                    <div className="row mt-2">
                      <div className="form-group col-sm-12">
                        <label htmlFor="finance_comment">หมายเหตุการขาย</label>
                        <br/>

                        {
                          this.state.sell_comment === null || this.state.sell_comment === '' ? '' : parse(this.state.sell_comment)
                        }

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header card-sparepart">
                    <strong className="text-title">ประวัติการชำระเงิน</strong>

                    <Button type="button" onClick={this.carSellPayAdd}
                            className="btn btn-info float-right">
                      <i className="icon-plus"/>&nbsp;&nbsp;เพิ่มการชำระเงิน
                    </Button>
                  </div>

                  <table className="table table-bordered table-striped table-md">
                    <thead>
                    <tr>
                      <th className="text-center" width="15%">วันที่</th>
                      <th className="text-center" width="25%">รายการ</th>
                      <th className="text-center" width="15%">จำนวนเงินที่ชำระ</th>
                      <th className="text-center" width="20%">ประเภทการรับชำระ</th>
                      <th className="text-center" width="20%">ธนาคาร</th>
                      <th className="text-center" width="20%">โดย</th>
                      <th className="text-center" width="20%">จัดการ</th>
                    </tr>
                    </thead>
                    <tbody>
                      {car_sell_pay_tr}
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </TabPane>
        </TabContent>


        <Modal isOpen={this.state.toggle_pay_add}
               toggle={this.toggleCarSellPayAdd}
               className={'modal-lg ' + this.props.className}
               style={width<=980 ?{maxWidth:800}:{maxWidth:1200}}
        >
          <ModalBody>
            <form
              action="" method="post"
              onSubmit={ this.handleCarSellPayAddSubmit }
            >

              <div className="card card-accent-info">
                <div className="card-header">
                  <strong className="text-title">เพิ่มการชำระเงิน</strong>
                </div>
                <div className="card-block">
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="date_pay">วันที่ชำระเงิน </label>
                      <br />
                      <DatePicker
                        selected={this.state.date_pay}
                        onChange={this.handleDatePay}
                        dateFormat="YYYY-MM-dd"
                        type="text"
                        className="form-control"
                        id="date_pay"
                        name="date_pay"
                        placeholder="วันที่ชำระเงิน"
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="car_repair_complete">รายการ </label>
                      <select
                        className="form-control"
                        id="car_sell_list_pay_id"
                        ref="car_sell_list_pay_id"
                        value={this.state.car_sell_list_pay_id}
                        onChange={(e)=>{
                          const { target } = e
                          this.setState({
                            car_sell_list_pay_id: target.value
                          });
                        }}
                      >
                        <option value=''>เลือกรายการ</option>
                        {car_sell_list_pay_list}
                      </select>

                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="car_sell_pay_count">จำนวนเงินที่ชำระ </label>
                      <input type="text"
                             className="form-control hidden"
                             id="car_sell_pay_count"
                             name="car_sell_pay_count"
                             placeholder=""
                             ref="car_sell_pay_count"
                             value={this.state.car_sell_pay_count}
                             onChange={()=>{}}
                      />
                      <NumberFormat
                        className="form-control"
                        thousandSeparator={true}
                        prefix={'฿'}
                        //placeholder="กรอกค่าโอน"
                        min={0}
                        max={1000000000}
                        step={1000}
                        size={10}
                        allowNegative={false}
                        value={this.state.car_sell_pay_count}
                        onValueChange={(values) => {
                          const {value} = values
                          this.setState({car_sell_pay_count: value}, () => {
                          })
                        }}
                      />


                      <input type="text hidden"
                             className="form-control hidden"
                             id="car_sell_pay_count_old"
                             name="car_sell_pay_count_old"
                             placeholder=""
                             ref="car_sell_pay_count_old"
                             value={this.state.car_sell_pay_count_old}
                             onChange={()=>{}}
                      />

                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="car_sell_pay_count">ประเภทการชำระ </label>
                      <select
                        className="form-control"
                        id="sales_type_id"
                        ref="sales_type_id"
                        value={this.state.sales_type_id}
                        onChange={this.carSalesPayTypeChange.bind(this)}
                      >
                        <option value=''>เลือกประเภทการรับชำระ</option>
                        {sales_type_list}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="bank_id">ธนาคาร </label>
                      <select
                        className="form-control"
                        id="bank_id"
                        name="bank_id"
                        ref="bank_id"
                        value={this.state.bank_id}
                        onChange={(e)=>{
                          const { target } = e
                          this.setState({
                            bank_id: target.value
                          });
                        }}
                      >
                        <option value=''>เลือกธนาคาร</option>
                        {bank_pay_list}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="card-footer text-right">
                  <button type="reset"
                          onClick={()=>{
                            this.setState({
                              toggle_pay_add: false
                            });
                          }}
                          className="btn btn-sm btn-danger mr-2">
                    <i className="fa fa-refresh"/> ยกเลิก
                  </button>

                  <button type="submit"
                          className="btn btn-sm btn-primary">
                    <i className="fa fa-plus"/> เพิ่มชำระเงิน
                  </button>

                  <input type="hidden" id="car_sell_pay_id" name="car_sell_pay_id" value={this.state.car_sell_pay_id}/>

                </div>
              </div>

            </form>
          </ModalBody>
        </Modal>


        {/* Modal */}
        <Modal isOpen={this.state.toggle_car_sell_pay_edit}
               toggle={this.toggleCarSellPayEdit.bind(this)}
               className={'modal-lg'}
        >
                {/* <ModalHeader toggle={this.toggleCarSellEdit.bind(this)}>แก้ไขการชำระเงิน</ModalHeader> */}
          <ModalBody>
            <form
              action="" method="post"
              onSubmit={ this.handleCarSellPayEditSubmit }
            >

            <div className="card card-accent-warning">
              <div className="card-header card-sparepart">
                <strong className="text-title">แก้ไขการชำระเงิน</strong>
              </div>
              <div className="card-block">
                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="date_pay">วันที่ชำระเงิน </label>
                    <br/>
                    <DatePicker
                      selected={this.state.date_pay}
                      onChange={this.handleDatePay}
                      dateFormat="YYYY-MM-dd"
                      type="text"
                      className="form-control"
                      id="date_pay"
                      name="date_pay"
                      placeholder="วันที่ชำระเงิน"
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="car_repair_complete">รายการ </label>
                    <select
                      className="form-control"
                      id="car_sell_list_pay_id"
                      ref="car_sell_list_pay_id"
                      value={this.state.car_sell_list_pay_id}
                      onChange={(e)=>{
                        const { target } = e
                        this.setState({
                          car_sell_list_pay_id: target.value
                        });
                      }}
                    >
                      <option value=''>เลือกรายการ</option>
                      {car_sell_list_pay_list}
                    </select>

                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="car_sell_pay_count">จำนวนเงินที่ชำระ </label>
                    <input type="text"
                           className="form-control hidden"
                           id="car_sell_pay_count"
                           name="car_sell_pay_count"
                           placeholder=""
                           ref="car_sell_pay_count"
                           value={this.state.car_sell_pay_count}
                           onChange={()=>{}}
                    />
                    <NumberFormat
                      className="form-control"
                      thousandSeparator={true}
                      prefix={'฿'}
                      //placeholder="กรอกค่าโอน"
                      min={0}
                      max={1000000000}
                      step={1000}
                      size={10}
                      allowNegative={false}
                      value={this.state.car_sell_pay_count}
                      onValueChange={(values) => {
                        const {value} = values
                         this.setState({car_sell_pay_count: value}, () => {
                        })
                      }}
                    />


                    <input type="text hidden"
                           className="form-control hidden"
                           id="car_sell_pay_count_old"
                           name="car_sell_pay_count_old"
                           placeholder=""
                           ref="car_sell_pay_count_old"
                           value={this.state.car_sell_pay_count_old}
                           onChange={()=>{}}
                    />

                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="car_sell_pay_count">ประเภทการชำระ </label>
                    <select
                      className="form-control"
                      id="sales_type_id"
                      ref="sales_type_id"
                      value={this.state.sales_type_id}
                      onChange={this.carSalesPayTypeChange.bind(this)}
                    >
                      <option value=''>เลือกประเภทการรับชำระ</option>
                      {sales_type_list}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="bank_id">ธนาคาร </label>
                    <select
                      className="form-control"
                      id="bank_id"
                      name="bank_id"
                      ref="bank_id"
                      value={this.state.bank_id}
                      onChange={(e)=>{
                        const { target } = e
                        this.setState({
                          bank_id: target.value
                        });
                      }}
                    >
                      <option value=''>เลือกธนาคาร</option>
                      {bank_pay_list}
                    </select>
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button type="reset"
                        onClick={()=>this.toggleCarSellPayEdit()}
                        className="btn btn-sm btn-danger mr-2">
                  <i className="fa fa-refresh"/> ยกเลิก
                </button>

                <button type="submit"
                        className="btn btn-sm btn-warning">
                  <i className="fa fa-pencil"/> แก้ไข
                </button>

                <input type="hidden" id="car_sell_pay_id" name="car_sell_pay_id" value={this.state.car_sell_pay_id}/>

              </div>
            </div>

            </form>
          </ModalBody>
          {/* <ModalFooter>
          </ModalFooter> */}
        </Modal>

      </div>

    )
  }
}

const styles = {
  fileInputWrapper: {
    position: 'relative',
    overflow: 'hidden',
    height: 120,
    width: 200,
  },
  bottomLine: {
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
    borderWidth: 0.5,
  },
  bottomLineAndMargin: {
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
    borderWidth: 0.5,
    paddingTop: 8
  },
  btnFileInput: {
    height: 120,
    width: 200,
    display: 'inline-block',
    backgroundColor: "#D2DDE2",
    backgroundImage: "linear-gradient(to bottom, #D2DDE2, #FCF8FF)",
    backgroundRepeat: "repeat-x",
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)"
  },
  btnFileInputImage:{
    position: 'absolute',
    top: 0,
    left: 0,
    height: 120,
    width: 200,
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: 0,
    height: 120,
    width: 200,
    cursor: 'pointer'
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(SalesDetail)
